<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click=""></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">作业管理&gt;</div>
      </div>
      <div class="body_content">
        <div class="situation_all_div">
          <div class="situation_one_div">
            <label>作业名称：</label>{{info.name}}
          </div>
          <div class="situation_one_div">
            <label>作业要求：</label>{{info.summary}}
          </div>
          <div class="situation_one_div">
            <label>附件：</label><a @click="openPreviewModal(info.fileName, info.filePath)">{{info.fileName}}</a>
          </div>
        </div>
       <!-- <div v-if="tea_clazzStatus == -1" class="classList_div">
          <table class="table table-striped tabShow">
            <thead>
            <tr>
              <th width="15%">学员名称</th>
              <th width="15%">学员作业</th>
              <th width="15%">评分</th>
              <th width="50%">评语</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(li, index) in list" :key="index">
              <td width="15%">{{li.studentName}}</td>
              <td width="15%">
                <a @click="openPreviewModal(li.fileName, li.filePath)" class="break_all">
                  {{li.fileName}}
                </a>
              </td>
              <td width="15%">{{li.score}}</td>
              <td width="50%">{{li.remark}}</td>
            </tr>
            </tbody>
          </table>
        </div>-->
        <div class="classList_div">
          <table class="table table-striped tabShow">
            <thead>
            <tr>
              <th width="15%">学员名称</th>
              <th width="15%">学员作业</th>
              <th width="15%">评分</th>
              <th width="40%">评语</th>
              <th width="10%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(li, index) in list" :key="index">
              <td width="15%">{{li.studentName}}</td>
              <td width="15%">
                <a @click="openPreviewModal(li.fileName, li.filePath)" class="break_all">
                  {{li.fileName}}
                </a>
                <a :href="hrefExport+li.filePath" v-if="li.filePath">【下载】</a>
              </td>
              <td width="15%">
                <!-- <select class="form-control" v-model="li.score" @change="updateScore(index)">
                   <option value="">未评分</option>
                   <option v-for="(val, key, sel_index) in scoreOption" :key="sel_index" :value="key">{{val}}</option>
                 </select>--><!--numeric -->
                <input type="number" min="0" max="100"  name="score" class="form-control modelInput" v-model="li.score" autocomplete="off">
              </td>
              <td width="40%" v-if="li.remark && li.remark != ''" class="tabTd_content_ellipsis" @dblclick="show_edit(index)">
                {{li.remark}}
              </td>
              <td width="40%" v-else class="tabTd_content_ellipsis" @dblclick="show_edit(index)">
                双击修改评语>>
              </td>
              <td width="10%">
                <button type="button" class="btn btn-default" @click="updateScore(index)">确定</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>


        <!--图片显示-->
        <div class="modal fade" id="myModal_showAllImages" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showAllImages" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showAllImages">
                  图片预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <img :src="imageSrc" class="previewImg"/>
              </div>
            </div>
          </div>
        </div>

        <!--视频显示-->
        <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showVideo">
                  视频预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <video ref="showVideo" class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
                </video>
              </div>
            </div>
          </div>
        </div>

        <!--文档显示-->
        <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog modal-dialog-look">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_showFile">
                  文档预览
                </h4>
              </div>
              <div class="modal-body modal-body-look">
                <iframe :src="fileSrc" width="100%" height="700px" style="height:calc(100vh - 150px);"></iframe>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop='static'>
          <div class="modal-dialog" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);width: 406px">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel">
                  输入评语
                </h4>
              </div>
              <div class="modal-body">
                学员：{{edit_remark.studentName}}
                <textarea v-validate="'required|maxL:200'" data-vv-scope="teaWork" data-vv-as="评语" name="teaRemark" rows="10" cols="50" style="resize: none" placeholder="输入评语" v-model="edit_remark.remark"></textarea>
                <!--<span class="spanRed">*</span>-->
                <span class="validateTip">{{ errors.first('teaWork.teaRemark') }}</span>
              </div>
              <div class="modal-footer">
                <!--@click="updateRemark()"-->
                <button type="button" class="btn btn-default btn_save" @click="updateRemark()">保存</button>
                <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  import dictionaryData from '../json/dictionary';

  export default {
    name: "homeworkManageTeaDetails",
    data() {
      return {
        tea_clazzId: this.$store.state.tea_clazzId,
        tea_schoolworkId: this.$store.state.tea_schoolworkId,
        tea_clazzStatus: this.$store.state.tea_clazzStatus,

        info: {},

        list: [],

        scoreOption: dictionaryData.school_score,

        //图片
        imageSrc: '',

        //视频
        videoSrc: '',
        videoThumbSrc: '',
        videoType: 'video/mp4',

        //文档
        fileSrc: '',

        edit_remark: {
          studentName: '',
          id: '',
          score: '',
          remark: '',
          index: ''
        },
        hrefExport:this.$store.state.serviceBase+"resources/",
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.load();
        this_.initHomeworkManageTeaDetailsData();
        this_.closeModal();
      });
    },
    methods: {
      /**
       * 初始加载数据
       */
      initHomeworkManageTeaDetailsData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'studentSchoolwork/findListByTeacherId',
          params: {
            //clazzId: this_.tea_clazzId,
            schoolworkId: this_.tea_schoolworkId
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.list = data.list;
          }
        });
      },

      /**
       * 加载作业详情
       */
      load(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'schoolwork/load/'+this_.tea_schoolworkId,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.info = data.data;
          }
        });
      },

      /**
       * 修改成绩
       */
      updateScore(index){
        let this_ = this;
        // this_.$validator.validateAll('stuScore').then(result => {
        //   if (result) {
            let my_data = this_.list[index];
            if(!my_data.score){
              "该作业还未打分".showMessage();
              return false;
            }
            schoolAxios({
              method: 'put',
              url: 'studentSchoolwork/editScoreAndRemark',
              data: {
                id: my_data.id,
                score: my_data.score,
                remark: my_data.remark
              }
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                this_.initHomeworkManageTeaDetailsData();
                "保存成功".showMessage();
              }else {
                data.message.showMessage();
              }
            });
          // }
        // });
      },

      /**
       * 修改评语弹出框
       */
      show_edit(index){
        let this_ = this;
        let my_data = this_.list[index];

        this_.edit_remark = {
          studentName: my_data.studentName || "",
          id: my_data.id || "",
          score: my_data.score || "",
          remark: my_data.remark || "",
          index:index
        }

        $("#myModal").modal("show");
      },

      /**
       * 修改成绩
       */
      updateRemark(){
        let this_ = this;
        this_.$validator.validateAll('teaWork').then(result => {
          if (result) {
            /*schoolAxios({
              method: 'put',
              url: 'studentSchoolwork/editScoreAndRemark',
              data: {
                id: this_.edit_remark.id,
                score: this_.edit_remark.score,
                remark: this_.edit_remark.remark
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                this_.initHomeworkManageTeaDetailsData();
              }
            })*/
            this_.list[this_.edit_remark.index].remark = this_.edit_remark.remark;
            $("#myModal").modal("hide");
          }
        });
      },

      closeModal(){
        let this_ = this;
        $('#myModal_showVideo').on('hide.bs.modal', function () {
          this_.videoSrc="";
        })
      },

      /**
       * 打开文件模态框
       */
      openFileModal(filePath) {
        let this_ = this;
        let data = filePath.substring(0, 11);
        let fileId = filePath.substring(11, filePath.indexOf('.'));
        this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
        $("#myModal_showFile").modal("show");
      },
      /**
       * 打开预览模态框
       */
      openPreviewModal(fileName, filePath) {
        let this_ = this;

        let suffix = fileName.substring(fileName.indexOf('.')+1);

        if("mp4".indexOf(suffix)!=-1){
          this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showVideo").modal("show");
        }else if("doc,docx,pdf".indexOf(suffix)!=-1) {
          let data = filePath.substring(0, 11);
          let fileId = filePath.substring(11, filePath.indexOf('.'));
          this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
          $("#myModal_showFile").modal("show");
        }else {
          this_.imageSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showAllImages").modal("show");
        }
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .situation_all_div {
    position: relative;
    top: 2%;
    left: 2%;
    width: 96%;
    height: 16%;
    font-size: 16px;
    line-height: 30px;
  }
  .situation_one_div label {
    width: 100px;
    text-align: right;
  }

  .classList_div {
    position: relative;
    top: 2%;
    width: 100%;
    height: 82%;
    overflow: auto;
  }

  .tabTd_content_ellipsis {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }

  .tabShow {
    margin: 0 0 0 0;
    width: 100%;
    max-height: 100%;
    table-layout: fixed;
  }
  .tabShow tr {
    /*border-bottom: 1px grey solid;*/
    height: 50px;
  }
  .tabShow tr td{
    border: 0px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
  }
  .tabShow tr th {
    background-color: #cccccc;
    color: black;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
  }
  /*.tabShow td {
    position: relative;
  }*/
  .tabShow tbody{
    height: 560px;
  }

  .modal-body-look {
    text-align: center;
  }
  .modal-body-look img {
    width: 100%;
  }
  .modal-dialog-look {
    width: 1080px;
  }
  .uploadBtn {
    margin: auto;
    width: 22px;
    height: 22px;
    background-image: url("../assets/img/right/student/uploadBtn.png");
    background-size: 100% 100%;
  }
  .uploadBtn:hover {
    background-image: url("../assets/img/right/student/uploadBtn_over.png");
  }
  .form-control.modelInput {
    width: 90%;
  }
  .editScoreSpan {
    position: absolute;
    top: 8%;
    left: 90%;
  }




</style>



// WEBPACK FOOTER //
// src/components/homeworkManageDetailsTea.vue